import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { GzLandingPageAppController } from '../controller/GzLandingPageAppController';

export class GzLandingPageAppWebComponent extends BaseWebComponentElement {
  public controller: GzLandingPageAppController;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: GzLandingPageAppController,
    });
  }
}
